module.exports = __webpack_public_path__ + "img/ajuda-card-02.101c629c.jpg";